export default __webpack_public_path__ + "static/media/Saveiro.0efbc7fd.png";